import { WordTaskActions } from '../../KnowAWord/WordTask/modules/WordTaskActions';
export class MemorizePointsWordTaskActions extends WordTaskActions {
    constructor(parent) {
        super(parent);
    }
    get wordTask() {
        return this.parent;
    }
    get question() {
        return this.wordTask.question;
    }
}
